import React, { useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../../lib/supabase'
import { Input } from '../../components/ui/Input'
import { Button } from '../../components/ui/Button'
import { CaptchaGate, type CaptchaHandle } from '../../components/security/CaptchaGate'
import { isCaptchaSatisfied } from '../../utils/captcha'
import { translateAuthError } from '../../utils/authErrors'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)
  const [captchaToken, setCaptchaToken] = useState<string | null>(null)
  const captchaRef = useRef<CaptchaHandle>(null)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!isCaptchaSatisfied(captchaToken)) {
      setError('Poczekaj na zakończenie weryfikacji antybotowej')
      return
    }

    setLoading(true)
    setError(null)
    setSuccess(null)
    try {
      const redirectTo = `${window.location.origin}/auth/update-password`
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo,
        captchaToken: captchaToken ?? undefined
      })
      if (error) throw error
      setSuccess('Wysłaliśmy link do resetu hasła. Sprawdź skrzynkę e‑mail.')
    } catch (err: any) {
      setError(translateAuthError(err) || 'Nie udało się wysłać linku resetującego')
      captchaRef.current?.reset()
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/20 flex items-center justify-center p-4">
      <div className="w-full max-w-md card-glass p-8">
        <div className="text-center mb-6">
          <h2 className="text-xl font-semibold text-slate-800">Reset hasła</h2>
          <p className="text-sm text-slate-600 mt-1">Podaj adres e‑mail, wyślemy link do zmiany hasła.</p>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">{error}</div>
        )}
        {success && (
          <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg text-green-700 text-sm">{success}</div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-slate-700 mb-1">E‑mail</label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="twoj@email.com"
              required
              className="w-full bg-white border-slate-200"
            />
          </div>

          <CaptchaGate ref={captchaRef} onToken={setCaptchaToken} action="reset_password" />

          <Button type="submit" disabled={loading} className="w-full">
            {loading ? 'Wysyłanie...' : 'Wyślij link resetujący'}
          </Button>
        </form>

        <div className="mt-6 text-center text-sm">
          <Link to="/auth/login" className="text-blue-600 hover:text-blue-700">Wróć do logowania</Link>
        </div>
      </div>
    </div>
  )
}


